import { useSetAtom } from 'jotai';
import { makeStyles } from '@material-ui/styles';

import { UserData, UserPreview } from '@bizzabo/entities';
import { Text } from '@bizzabo/design-system';

import MeetingItem from '../MeetingItem';
import { StatusMeeting, ScheduledMeeting } from '../../types';
import LocationDetails from '../LocationDetails';
import TimeInfo from '../TimeInfo';
import DateAndTime from '../DateAndTime';
import LocationBadge from '../LocationBadge';
import UserBadgeAction from '../UserBadgeAction';
import ItemDropdownMenu from '../ItemDropdownMenu';
import ItemDropdownMenuButton from '../ItemDropdownMenu/ItemDropdownMenuButton';
import { MeetingsToolsParamsAtom } from '../../../../appState/meetings/atoms';
import { MeetingsToolsParamsType } from '../../../../appState/meetings/types';

interface CancelledItemProps {
    meeting: ScheduledMeeting;
    user: UserPreview;
    currentUser: UserData;
}

const CancelledItem: React.FC<CancelledItemProps> = ({ meeting, user, currentUser }) => {
    const classes = useStyles();
    const setMeetingsToolsParamsAtom = useSetAtom(MeetingsToolsParamsAtom);

    const onScheduleClick = () => {
        setMeetingsToolsParamsAtom({
            type: MeetingsToolsParamsType.OpenWizard,
            otherAttendeeId: user.userProfileId,
        });
    };

    const currentParticipant = meeting.participants.find(
        participant => participant.userProfileId === currentUser.userProfileId
    );

    const isCurrentUserCanceled =
        currentParticipant.status === StatusMeeting.DELETED_INVITE_TO ||
        currentParticipant.status === StatusMeeting.DECLINED_INVITE_TO;

    return (
        <MeetingItem>
            {isCurrentUserCanceled ? (
                <Text variant="t81" className={classes.text}>
                    You canceled this invite
                </Text>
            ) : (
                <TimeInfo isDisabled>
                    <DateAndTime startDate={meeting.startDate} endDate={meeting.endDate} />
                    <LocationBadge locationType={meeting.locationType} />
                </TimeInfo>
            )}
            <UserBadgeAction user={user} hasNotification={!!meeting.notifications?.length}>
                <ItemDropdownMenu>
                    {closeDropdown => (
                        <>
                            <ItemDropdownMenuButton
                                onClick={() => {
                                    closeDropdown();
                                    onScheduleClick();
                                }}
                            >
                                Schedule a meeting
                            </ItemDropdownMenuButton>
                        </>
                    )}
                </ItemDropdownMenu>
            </UserBadgeAction>
            <LocationDetails physicalLocation={meeting.physicalLocation} isDisabled />
        </MeetingItem>
    );
};

const useStyles = makeStyles(
    () => ({
        text: {
            opacity: 0.6,
        },
    }),
    { classNamePrefix: 'meetings-cancelled-item' }
);

export default CancelledItem;
